import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Header } from "@/components/universal/header";
import { loadReleaseNotes, ReleaseNote } from "@/lib/load-release-notes";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { format } from "date-fns";

export const Route = createFileRoute("/_private/release-notes")({
  component: ReleaseNotesPage,
});

function ReleaseNotesPage() {
  const [releaseNotes, setReleaseNotes] = useState<ReleaseNote[]>([]);

  useEffect(() => {
    loadReleaseNotes().then((notes) => setReleaseNotes(notes));
  }, []);

  return (
    <div>
      <title>Release Notes - Legrande Health Portal</title>
      <Header
        crumbs={[{ name: "Release Notes", link: { to: "/release-notes" } }]}
      />
      <div className="space-y-4">
        {releaseNotes.map((note, index) => (
          <Card key={index}>
            <CardHeader>
              <CardTitle>Version {note.version}</CardTitle>
              <CardDescription>
                {format(new Date(note.date + "T00:00:00"), "MM-dd-yyyy")}
              </CardDescription>
            </CardHeader>
            <CardContent className="prose prose-sm max-w-none">
              <ReactMarkdown>{note.content}</ReactMarkdown>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
